import { makeStyles } from '@mui/styles'
import { forwardRef, useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { SnackbarContent, CustomContentProps } from 'notistack'
import { Card, CircularProgress, Stack, Typography } from '@mui/material'

import { UserContext } from '../../contexts'

const useStyles = makeStyles(() => ({
  root: {
    '@media (min-width:600px)': {
      minWidth: '344px !important'
    }
  },
  card: {
    width: '100%',
    padding: '15px',
    boxSizing: 'border-box'
  },
  typography: {
    display: 'flex',
    color: '#026AA2',
    fontSize: '16px',
    alignItems: 'center'
  }
}))

const CreatingReport = forwardRef<HTMLDivElement, CustomContentProps>(({ id, ...props }, ref) => {
  const classes = useStyles()
  const navigate = useNavigate()
  const { userSession } = useContext(UserContext)

  return (
    <SnackbarContent
      ref={ref}
      className={classes.root}
    >
      <Card
        className={classes.card}
        style={{ backgroundColor: '#B9E6FE' }}
      >
        <Stack
          spacing={2}
          direction="row"
          sx={{ color: '#026AA2' }}
        >
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <CircularProgress
              size="30px"
              color="inherit"
            />
          </div>
          <div
            style={{ cursor: 'pointer' }}
            onClick={() => navigate(`/requested-reports/${userSession?.belongsTo}`)}
          >
            <Typography
              variant="body2"
              className={classes.typography}
            >
              {props.message}
            </Typography>
          </div>
        </Stack>
      </Card>
    </SnackbarContent>
  )
})

CreatingReport.displayName = 'CreatingReport'

export default CreatingReport
